import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

/**
 * Resolve a media path (e.g. `/api/objstore/happy-home/hero/abc.png`) to an
 * absolute URL rooted on REACT_APP_BACKEND_URL. Works transparently on preview
 * and on the deployed production domain. Passes through URLs that are already
 * absolute (http/https/data:).
 */
export const resolveMediaUrl = (u) => {
  if (!u) return "";
  if (/^(https?:|data:|blob:)/i.test(u)) return u;
  return `${BACKEND_URL}${u.startsWith("/") ? "" : "/"}${u}`;
};

export const fetchHelpers = async (params = {}) => {
  const res = await api.get("/helpers", { params });
  return res.data;
};

export const fetchHelper = async (id) => {
  const res = await api.get(`/helpers/${id}`);
  return res.data;
};

export const submitContact = async (payload) => {
  const res = await api.post("/contact", payload);
  return res.data;
};

export const submitApplication = async (payload) => {
  const res = await api.post("/applications", payload);
  return res.data;
};
